/*
  SLIMZ USA — shared front-end behaviour (original, vanilla JS).
  Currently: scroll-reveal for elements carrying `.slimz-reveal`.
  Honors prefers-reduced-motion (no observer, content shown immediately).
  Section-specific behaviour (hero word, size compare, announcement) lives in
  the relevant section so it ships only where it is used.
*/
(function () {
  'use strict';

  function revealAll() {
    document.querySelectorAll('.slimz-reveal').forEach(function (el) {
      el.classList.add('slimz-in');
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.slimz-reveal');
    if (!nodes.length) return;

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('slimz-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-init when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', initReveal);
})();
